.SectionEditor {
	flex: 1;
	min-height: 30vh;
}